export default __webpack_public_path__ + "static/media/sandero-colour-11.1dc6dfe4.jpg";